import React, { useRef, useState } from "react";
import GoogleMapReact from "google-map-react";
const Marker = ({ }) => <div style={{ fontSize: "20px" }}>{"📍"}</div>;

export default function GMapPolygen({ lat, lng, set, close }) {
  console.log(lat,"long",lng)

  const google = window.google;
  const [polylatlan, setpolylatlan] = [{ lat: 18.619113300290866, lng: 73.7778838723898 },
  { lat: 18.61904117592195, lng: 73.77984222024679 },
  { lat: 18.617250130571186, lng: 73.77931851893663 },
  { lat: 18.617293342105583, lng: 73.77793684601784 }
  ];

  const mapRef = useRef();
  const [lldata, SetLLData] = useState({ lat, lng });
  const createMapOptions = {
    panControl: false,
    mapTypeControl: true,
    mapTypeId: "satellite",
    scrollwheel: false,
    draggableCursor: "default",
    draggingCursor: "pointer",
  };

  const defaultProps = {
    center: { lat, lng },
    zoom: 19,
  };
  const handleLatLong = () => {
    set(lldata);
    close(false);
  };

  return (
    <>
      <div style={{ height: "400px", width: "650px" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyABE5oLDQJp-iEBTdd1QdTi0J8io3ufq6o" }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map }) => {
            mapRef.current = map;
          }}
          onClick={(e) => SetLLData({ lat: e.lat, lng: e.lng })}
          options={createMapOptions}
        >


          <polygon paths={polylatlan} strokeColor="#0000FF"
            strokeOpacity={0.8}
            strokeWeight={2}
            fillColor="Red"
          />
          <Marker lat={lldata.lat} lng={lldata.lng} text="My Marker" />
        </GoogleMapReact>
      </div>

    </>
  );
}
